function getDomain() {
    const addr = location.protocol + '//' + location.host;
    const port = location.port;
    const isGeneric = (addr === "file://" || addr === "about://" || addr === "http://server");
    const includePort = (port && port !== 80 && port !== 443 && !addr.includes(port));
    return (isGeneric) ? '*' : addr + (includePort ? ':' + port : '');
}

export default function setupGlobalLaunch() {
    if (!window.NITAgent) { window.NITAgent = {}; }
    window.NITAgent.showAgentWithQuestion = function LaunchIVA (params) {
        const tp = params && (typeof params);
        params = (tp === 'string') ? { launchQuestion: params } :
                 (tp === 'object') ? params
                                   : {};
        if (params.question) { params.launchQuestion = params.question; }
        const message = Object.assign({}, params, { type: 'LaunchIVA', source: 'client' });
        setTimeout(() => window.postMessage(JSON.stringify({ message }), getDomain()), 100);
    };
}


// WEBPACK FOOTER //
// ./components/setupGlobalLaunch.js